import React, { ChangeEvent, memo } from 'react';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab';
import { FieldInputProps, useField } from 'react-final-form';
import InputNew from './InputNew';
import { InputFieldProps } from './utils';
import InputFieldWrapper from './InputFieldWrapper';

const handleInputChange = (input: FieldInputProps<string, HTMLElement>) => (
  _: ChangeEvent<{}>,
  newOption?: { value: string } | string | null
) => {
  if (typeof newOption === 'string') {
    if (newOption === '') {
      input.onChange(undefined);
    }
    return;
  }
  input.onChange(newOption?.value || undefined);
};

const handleRenderInput = (
  field: InputFieldProps
  // eslint-disable-next-line react/display-name
) => (params: AutocompleteRenderInputParams) => {
  const { input, meta } = useField(field.name);
  // `onChange` and `value` need to be omitted here, as they are for the Autocomplete component itself and not the textfield subcomponent
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { onChange, value, ...inputProps } = input;

  return (
    <InputNew
      field={field}
      meta={meta}
      wrapField={false}
      placeholder={field.placeholder}
      {...params}
      {...inputProps}
    />
  );
};

const FormSingleSelect = ({ field }: { field: InputFieldProps }) => {
  if (!field.options) {
    return null;
  }

  const { input } = useField(field.name);

  const value =
    field.options.find(option => option.value === input.value) ?? null;

  return (
    <InputFieldWrapper marginBottom={3}>
      <Autocomplete
        id={field.id}
        options={field.options}
        getOptionLabel={option => option.label || ''}
        onChange={handleInputChange(input)}
        onInputChange={(_, newInputValue) => {
          if (newInputValue === '') {
            input.onChange(undefined);
          }
        }}
        value={value}
        blurOnSelect
        autoHighlight
        autoSelect
        renderInput={handleRenderInput(field)}
      />
    </InputFieldWrapper>
  );
};

export default memo(FormSingleSelect);
